import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const LOGO =
  "https://customer-assets-agu9un31.emergentagent.net/job_labpronics-tech/artifacts/a7d11asc_ChatGPT%20Image%20Aug%204%2C%202026%2C%2003_51_10%20AM.png";

const CERTS = ["CMMI L3", "CMMI L5", "ISO 9001:2015", "ISO 20000", "ISO 27001", "DPIIT", "Startup Odisha"];

export default function Footer() {
  const { content } = useSite();
  const f = content?.footer || {};
  return (
    <footer className="bg-lp-blue text-white" data-testid="site-footer">
      <div className="container-lp py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <img src={LOGO} alt="Labpronics" className="h-12 w-12 object-contain bg-white rounded-full p-0.5" />
              <div className="font-heading font-700 text-lg">Labpronics Technologies</div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed max-w-xs">
              {f.description || "A CMMI Level 3 certified system integrator delivering surveillance, cybersecurity, command & control and smart-governance infrastructure for government and enterprise India."}
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading font-600 tracking-wide text-lp-cyan text-sm uppercase mb-4">Solutions</h4>
            <ul className="space-y-2.5 text-sm text-white/75">
              <li><Link to="/solutions" className="hover:text-white">Surveillance & AI</Link></li>
              <li><Link to="/solutions" className="hover:text-white">Command & Control</Link></li>
              <li><Link to="/solutions" className="hover:text-white">Coastal & Maritime</Link></li>
              <li><Link to="/solutions" className="hover:text-white">Cybersecurity</Link></li>
              <li><Link to="/solutions" className="hover:text-white">Data Centers & IT</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading font-600 tracking-wide text-lp-cyan text-sm uppercase mb-4">Company</h4>
            <ul className="space-y-2.5 text-sm text-white/75">
              <li><Link to="/about" className="hover:text-white">About Us</Link></li>
              <li><Link to="/projects" className="hover:text-white">Projects</Link></li>
              <li><Link to="/oem-partners" className="hover:text-white">OEM Partners</Link></li>
              <li><Link to="/certifications" className="hover:text-white">Certifications</Link></li>
              <li><Link to="/insights" className="hover:text-white">Insights</Link></li>
              <li><Link to="/admin" className="hover:text-white">Admin</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading font-600 tracking-wide text-lp-cyan text-sm uppercase mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex gap-3"><MapPin size={18} className="text-lp-cyan shrink-0 mt-0.5" /> {f.address || "Forum Mart, Kharvela Nagar, Bhubaneswar, Odisha 751001"}</li>
              <li className="flex gap-3"><Phone size={18} className="text-lp-cyan shrink-0" /> {f.phone || "+91 91786 77237"}</li>
              <li className="flex gap-3"><Mail size={18} className="text-lp-cyan shrink-0" /> {f.email || "info@labpronicstech.com"}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/15 flex flex-wrap gap-3">
          {CERTS.map((c) => (
            <span key={c} className="text-[11px] font-600 tracking-wide border border-white/25 rounded-sm px-3 py-1.5 text-white/80">{c}</span>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/55">
          <p>© {new Date().getFullYear()} Labpronics Technologies Private Limited. All rights reserved.</p>
          <div className="flex gap-5"><span>Privacy Policy</span><span>Terms of Use</span></div>
        </div>
      </div>
    </footer>
  );
}
